!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, i = {}, s = e.parcelRequire5f74;
  null == s && ((s = function(e) {
    if (e in t) return t[e].exports;
    if (e in i) {
      var s = i[e];
      delete i[e];
      var n = {
        id: e,
        exports: {}
      };
      return t[e] = n, s.call(n.exports, n, n.exports), n.exports;
    }
    var a = new Error("Cannot find module '" + e + "'");
    throw a.code = "MODULE_NOT_FOUND", a;
  }).register = function(e, t) {
    i[e] = t;
  }, e.parcelRequire5f74 = s), (0, s.register)("gjV2B", function(e, t) {
    var i, s, n, a;
    i = e.exports, s = "debounce", n = function() {
      return r;
    }, Object.defineProperty(i, s, {
      get: n,
      set: a,
      enumerable: !0,
      configurable: !0
    });
    const r = (e, t) => {
      let i;
      const s = (...s) => {
        clearTimeout(i), i = setTimeout(() => {
          clearTimeout(i), e(...s);
        }, t);
      };
      return s.cancel = () => {
        clearTimeout(i), i = null;
      }, s;
    };
  });
  var n = s("gjV2B");
  customElements.get("product-details") || customElements.define("product-details", class extends HTMLElement {
    constructor() {
      super(), this.asideEl = this.querySelector(".product-modal-details__aside"), this.reviewsContainerEl = this.querySelector(".pmd__reviews #ReviewsWidget"), 
      this.tabList = this.asideEl?.querySelector(".product-modal-details__subnavigation"), 
      this.contentContainer = this.querySelector(".product-modal-details__content"), this.tabs = [], 
      this.panels = [], this.radioInputs = [], this.currentTabIndex = 0, this.desktopMQ = window.matchMedia("(min-width: 1024px)"), 
      this.resizeObserver = null, this.sectionId = this.closest(".section")?.id.replace("shopify-section-", ""), 
      this.debouncedReviewContainer = (0, n.debounce)(this.setReviewContainerWidth.bind(this), 200), 
      this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this), this.handleRadioChange = this.handleRadioChange.bind(this);
    }
    connectedCallback() {
      this.handleMediaQueryChange(), this.initializeTabs(), this.desktopMQ.addEventListener("change", this.handleMediaQueryChange);
    }
    disconnectedCallback() {
      this.desktopMQ.removeEventListener("change", this.handleMediaQueryChange), this.teardownTabs(), 
      this.destroyDesktop();
    }
    handleMediaQueryChange() {
      this.desktopMQ.matches ? this.setupDesktop() : this.destroyDesktop();
    }
    setupDesktop() {
      this.tabList && this.contentContainer && (this.setReviewContainerWidth(), this.resizeObserver = new ResizeObserver(this.debouncedReviewContainer), 
      this.resizeObserver.observe(this));
    }
    destroyDesktop() {
      this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null), 
      this.reviewsContainerEl && requestAnimationFrame(() => {
        this.reviewsContainerEl.style.width = "";
      });
    }
    initializeTabs() {
      const e = Array.from(this.tabList.querySelectorAll('label[for^="ProductDetails-"]'));
      e.length && (this.tabs = e, this.tabs.forEach((e, t) => {
        const i = e.getAttribute("for"), s = this.querySelector(`#${i}`), n = this.getPanelForTab(e);
        if (!s || !n) return;
        this.radioInputs[t] = s, this.panels[t] = n;
        const a = `panel-${i}`, r = `tab-${i}`;
        e.setAttribute("id", r), e.setAttribute("aria-controls", a), n.setAttribute("id", a), 
        n.setAttribute("aria-labelledby", r), s.checked && (this.currentTabIndex = t), s.addEventListener("change", this.handleRadioChange);
      }), this.updateTabAndPanelStates(this.currentTabIndex));
    }
    teardownTabs() {
      this.tabs.forEach((e, t) => {
        const i = this.radioInputs[t], s = this.panels[t];
        i && i.removeEventListener("change", this.handleRadioChange), e.removeAttribute("id"), 
        e.removeAttribute("aria-controls"), e.removeAttribute("aria-selected"), e.removeAttribute("tabindex"), 
        s && (s.removeAttribute("id"), s.removeAttribute("aria-labelledby"), s.removeAttribute("inert"), 
        s.removeAttribute("aria-expanded"));
      }), this.tabs = [], this.panels = [], this.radioInputs = [];
    }
    handleRadioChange(e) {
      this.contentContainer.scrollTo({
        top: 0
      });
      const t = e.target, i = this.radioInputs.indexOf(t);
      -1 !== i && t.checked && (this.updateTabAndPanelStates(i), this.currentTabIndex = i, 
      this.focusOnActivePanel(i), this.announceTabChange(this.tabs[i]));
    }
    updateTabAndPanelStates(e) {
      this.tabs.forEach((t, i) => {
        const s = i === e, n = this.panels[i];
        t.setAttribute("aria-selected", s), n && (s ? n.removeAttribute("inert") : n.setAttribute("inert", ""), 
        n.setAttribute("aria-expanded", s));
      });
    }
    focusOnActivePanel(e) {
      const t = this.panels[e];
      t && requestAnimationFrame(() => {
        const e = t.querySelector('a, button, label, summary, input, [tabindex]:not([tabindex="-1"])');
        e ? e.focus() : t.focus();
      });
    }
    announceTabChange(e) {
      const t = e.textContent.trim(), i = document.createElement("div");
      i.setAttribute("aria-live", "polite"), i.setAttribute("aria-atomic", "true"), i.className = "sr-only", 
      i.textContent = `${t} ${window.strings?.product_details_tab_selected || "tab selected"}`, 
      document.body.appendChild(i), setTimeout(() => document.body.removeChild(i), 1e3);
    }
    setReviewContainerWidth() {
      this.reviewsContainerEl && this.asideEl && requestAnimationFrame(() => {
        const e = this.offsetWidth - this.asideEl.offsetWidth;
        this.reviewsContainerEl.style.width = this.desktopMQ.matches ? e - 40 + "px" : "";
      });
    }
    getPanelForTab(e) {
      const t = e.getAttribute("for").split("-").slice(2).join("-"), i = `[data-detail-type="ProductDetails-${this.sectionId}-${t}"]`;
      return this.contentContainer.querySelector(i);
    }
  });
}();